import RetailAnalyticsView from './retail';
import OnDemandAnalyticsView from './ondemand';
import {
  registerAnalyticsView,
  getViewControl,
  getViewBuckets,
  getViewCharts,
} from './analyticsViewRegistry';

registerAnalyticsView('retail', RetailAnalyticsView);
registerAnalyticsView('ondemand', OnDemandAnalyticsView);

export { getViewControl, getViewBuckets, getViewCharts };
